import { cn } from '@massilia/ui'
import { AlertCircle, CheckCircle, Info } from 'lucide-react'

interface ImportantNoticeProps {
  children: React.ReactNode
  title?: string
  variant?: 'info' | 'success' | 'warning'
}

const variants = {
  info: {
    container: 'border-blue-200 bg-blue-50/50',
    icon: Info,
    iconColor: 'text-blue-600',
    titleColor: 'text-blue-800',
  },
  success: {
    container: 'border-emerald-200 bg-emerald-50/50',
    icon: CheckCircle,
    iconColor: 'text-emerald-600',
    titleColor: 'text-emerald-800',
  },
  warning: {
    container: 'border-amber-200 bg-amber-50/50',
    icon: AlertCircle,
    iconColor: 'text-amber-600',
    titleColor: 'text-amber-800',
  },
}

export function ImportantNotice({ children, title, variant = 'info' }: ImportantNoticeProps) {
  const config = variants[variant]
  const Icon = config.icon

  return (
    <div
      className={cn(
        'flex gap-3 rounded-xl border p-4',
        'animate-in fade-in slide-in-from-left-2',
        config.container
      )}
    >
      <Icon className={cn('h-5 w-5 shrink-0', config.iconColor)} />
      <div className="flex-1 space-y-1">
        {title && <p className={cn('text-sm font-medium', config.titleColor)}>{title}</p>}
        <div className="text-sm leading-relaxed text-stone-600">{children}</div>
      </div>
    </div>
  )
}
